// extracted by mini-css-extract-plugin
export default {"modalWrapper":"delete-prompt_modalWrapper__7LIf8","buttonWrapper":"delete-prompt_buttonWrapper__2Yg5b"};